import { authHeader } from '@/_helpers';
import {API_URL} from "../config/app";
import Cookies from 'js-cookie';

const URL = API_URL

export const userService = {
  login,
  refreshToken,
  logout,
  refreshUserInfo,
  changeCompany,
  smsVerification,
  smsVerificationCode,
  inviteUser,
  acceptInvitation,
  getApiKey,
  resetApiKey,
  register,
  resend_verification_email,
  createPassword,
  forgotPasswordRequest,
  forgotPassword,
  accountActivation,
  changePassword,
  getAll,
  getById,
  update,
  promoteRole,
  onBoardingQuestions,
  getOnboardingPrefill,
  getDefaultSettings,
  storeDefaultSettings,
  delete: _delete
};

function login(email, password, aclChangeRole) {
  console.log(URL);
  let details = {
    username: email,
    password
  }
  var formBody = [];
  for (var property in details) {
    var encodedKey = encodeURIComponent(property);
    var encodedValue = encodeURIComponent(details[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }
  formBody = formBody.join("&");

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: formBody
  };

  return fetch(URL + "/users/login", requestOptions)
    .then(handleLoginResponse)
    .then(response => {
      let user = {}
      // Login successful if there's a jwt token in the response
      // Store user details and jwt token in local storage to keep user logged in between page refreshes
      user = {
        token: response.access_token,
        refresh_token: response.refresh_token
      }
      localStorage.setItem('user', JSON.stringify(user));

      return me().then(response => {
        user['me'] = {
          name: response.data[0].attributes.name.trim(),
          last_name: response.data[0].attributes.last_name.trim(),
          phone: response.data[0].attributes.phone,
          email: response.data[0].attributes.email,
          on_boarding: response.data[0].attributes.on_boarding,
          owned_companies: response.data[0].relationships.owned_companies.data,
          invited_companies: response.data[0].relationships.invited_companies.data,
          selected_company: selectFirstCompany(response, aclChangeRole),
          subscription_credits: response.data[0].relationships.subscription.data[0].attributes.free_credits,
          plan: response.data[0].relationships.subscription.data[0].relationships.plan.data[0].attributes,
          free_credits_from_credits_packs: response.data[0].relationships.credit_pack_info.data[0].attributes.freeCredits,
          active: response.data[0].relationships.subscription.data[0].attributes.active,
          tax_data: response.data[0].relationships.tax_data.data,
        }
        user.me.plan.id = response.data[0].relationships.subscription.data[0].relationships.plan.data[0].id;
        localStorage.setItem('user', JSON.stringify(user));
        return user;
      })

    });
}

function selectFirstCompany(response, aclChangeRole) {
  if (Array.isArray(response.data[0].relationships.owned_companies.data) && response.data[0].relationships.owned_companies.data.length) {
    let selectedCompany = response.data[0].relationships.owned_companies.data[0];
    selectedCompany["role"] = "owner";
    aclChangeRole("owner")
    return selectedCompany;
  } else if (Array.isArray(response.data[0].relationships.invited_companies.data) && response.data[0].relationships.invited_companies.data.length) {
    let selectedCompany = response.data[0].relationships.invited_companies.data[0];
    aclChangeRole(selectedCompany.role)
    return selectedCompany;
  } else {
    aclChangeRole("owner")
    return {
      role: "owner"
    }
  }
}

function refreshUserInfo(aclChangeRole) {
  let user = JSON.parse(localStorage.getItem('user'));
  return me().then(response => {
    user['me'] = {
      name: response.data[0].attributes.name.trim(),
      last_name: response.data[0].attributes.last_name.trim(),
      phone: response.data[0].attributes.phone,
      email: response.data[0].attributes.email,
      on_boarding: response.data[0].attributes.on_boarding,
      owned_companies: response.data[0].relationships.owned_companies.data,
      invited_companies: response.data[0].relationships.invited_companies.data,
      selected_company: user.me.selected_company ? user.me.selected_company.id ? user.me.selected_company : selectFirstCompany(response, aclChangeRole) : selectFirstCompany(response, aclChangeRole),
      subscription_credits: response.data[0].relationships.subscription.data[0].attributes.free_credits,
      plan: response.data[0].relationships.subscription.data[0].relationships.plan.data[0].attributes,
      active: response.data[0].relationships.subscription.data[0].attributes.active,
      free_credits_from_credits_packs: response.data[0].relationships.credit_pack_info.data[0].attributes.freeCredits,
      tax_data: response.data[0].relationships.tax_data.data
    }
    user.me.plan.id = response.data[0].relationships.subscription.data[0].relationships.plan.data[0].id;
    localStorage.setItem('user', JSON.stringify(user));
    return user;
  });
}

function me() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(URL + "/users", requestOptions)
    .then(handleResponse)
    .then(response => {
      return response
    })
}

function changeCompany(company, role) {
  let user = JSON.parse(localStorage.getItem('user'));
  company['role'] = role;
  user.me.selected_company = company;
  localStorage.setItem('user', JSON.stringify(user));
}

function smsVerification(phone) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  let buildUrl = URL + "/users/sms?phone=" + encodeURIComponent(phone);

  return fetch(buildUrl, requestOptions).then(handleResponse);
}

function smsVerificationCode(code, phone) {
  let formData = new FormData();
  formData.append("phone", phone);
  formData.append("code", code);
  if (Cookies.get('utm_source'))
    formData.append("source", Cookies.get('utm_source'))
  if (Cookies.get('utm_medium'))
    formData.append("medium", Cookies.get('utm_medium'))
  if (Cookies.get('utm_campaign'))
    formData.append("campaign", Cookies.get('utm_campaign'))

  let headers = authHeader();
  delete headers['Content-Type']

  const requestOptions = {
    method: 'POST',
    headers: headers,
    body: formData
  };

  return fetch(URL + "/users/sms", requestOptions).then(handleResponse);
}

function changePassword(currentPasword, newPassword, newPasswordConfirmation) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify({
      current_password: currentPasword,
      new_password: newPassword,
      new_password_confirmation: newPasswordConfirmation
    })
  };

  return fetch(URL + "/me/change-password", requestOptions).then(handleResponse);
}

function inviteUser(user, company_id) {
  let formData = new FormData();
  formData.append("name", user.name);
  formData.append("last_name", user.last_name);
  formData.append("email", user.email);
  formData.append("role", user.role);

  let headers = authHeader();
  delete headers['Content-Type']

  const requestOptions = {
    method: 'POST',
    headers: headers,
    body: formData
  };

  return fetch(URL + "/companies/" + company_id + "/users", requestOptions).then(handleResponse);
}

function acceptInvitation(name, password, password_confirmation, token) {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({name, password, password_confirmation, token})
  };

  return fetch(URL + "/invites/accept", requestOptions).then(handleResponse);
}

function refreshToken() {
  let user = JSON.parse(localStorage.getItem("user"));
  let formData = new FormData();
  formData.append("refresh_token", user.refresh_token);

  const requestOptions = {
    method: 'POST',
    body: formData
  };

  fetch(URL + "/users/refresh_token", requestOptions).then(response => {
    if (response.ok) {
      response.json().then(
        parsedResponse => {
          user.token = parsedResponse.access_token;
          user.refresh_token = parsedResponse.refresh_token;
          localStorage.setItem("user", JSON.stringify(user));
          setTimeout(() => {
            location.reload();
          }, 100);
        }
      )
    } else {
      this.logout();
      setTimeout(() => {
        location.reload();
      }, 100)
    }
  })
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem('user');
}

function register(user) {
  if (user.isBot) {
    const requestOptions = {
      method: 'GET'
    };
    return fetch("/signature/signup-verify.json", requestOptions)
      .then(handleResponse)
      .then(data => {
        if (data && data.data) {
          data.data.email = user.email;
          data.data.name = user.name;
          data.data.last_name = user.last_name;
        }
        return data;
      });
  }

  let formData = new FormData()
  formData.append("email", user.email);
  formData.append("name", user.name);
  formData.append("last_name", user.last_name);
  formData.append("password", user.password);
  formData.append("utm_medium", user.utm_medium);
  formData.append("utm_source", user.utm_source);
  formData.append("utm_campaign", user.utm_campaign);
  formData.append("gclid", user.gclid);
  formData.append("fbclid", user.fbclid);
  if (user.coupon) {
    formData.append("coupon", user.coupon);
  }
  const requestOptions = {
    method: 'POST',
    body: formData
  };

  return fetch(URL + "/users", requestOptions).then(handleResponse);
}

function resend_verification_email(email) {
  let formData = new FormData()
  formData.append("email", email);
  const requestOptions = {
    method: 'POST',
    body: formData
  };

  return fetch(URL + "/users/resend-verification", requestOptions).then(handleResponse);
}

function createPassword(password, password_confirmation, token) {
  let formData = new FormData()
  formData.append("password", password);
  formData.append("password_confirm", password_confirmation);
  const requestOptions = {
    method: 'PATCH',
    body: formData
  };

  return fetch(URL + "/users/activation/" + token, requestOptions).then(handleResponse);
}

function forgotPasswordRequest(email) {
  let formData = new FormData()
  formData.append("email", email);
  const requestOptions = {
    method: 'POST',
    body: formData
  };

  return fetch(URL + "/users/reset_password", requestOptions).then(handleResponse);
}

function forgotPassword(password, password_confirmation, token) {
  let formData = new FormData()
  formData.append("password", password);
  formData.append("password_confirm", password_confirmation);
  const requestOptions = {
    method: 'PATCH',
    body: formData
  };

  return fetch(URL + "/users/reset_password/" + token, requestOptions).then(handleResponse);
}

function accountActivation(uuid, hash) {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({uuid, hash})
  };

  return fetch(URL + "/verify/email", requestOptions).then(handleResponse);
}

function getApiKey() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(URL + "/api_keys", requestOptions)
    .then(handleResponse)
    .then(response => {
      let apiKeyId = response.data[0].id;
      let apiKeySecret = response.data[0].attributes['secret'];

      return Promise.resolve({
        apiKeyId, apiKeySecret
      })
    })

}

function resetApiKey() {
  const requestOptions = {
    method: 'PATCH',
    headers: authHeader()
  };

  return fetch(URL + "/api_keys", requestOptions)
    .then(handleResponse)
    .then(response => {

      let apiKeyId = response.data[0].id;
      let apiKeySecret = response.data[0].attributes['secret'];

      return Promise.resolve({
        apiKeyId, apiKeySecret
      })
    })
}

function getAll(page, sort, company_id, search) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  let parameters = '';
  if (page) {
    parameters += '?page=' + page
  } else {
    parameters += '?page=0'
  }
  if (sort) {
    if (page) {
      parameters += '&sort=' + sort
    } else {
      parameters += '?sort=' + sort
    }
  } else {
    parameters += '&sort=urc.role.displayName,DESC'
  }
  if (search) {
    if (page || sort) {
      parameters += '&filter[name]=' + search
    } else {
      parameters += '?filter[name]=' + search
    }
  }

  return fetch(URL + "/companies/" + company_id + "/users" + parameters, requestOptions)
    .then(handleResponse)
    .then(response => {

      let data = [];
      response.data.forEach(resp => {
        data.push({
          id: resp.id,
          name: resp.attributes.name,
          email: resp.attributes.email,
          last_name: resp.attributes.last_name,
          phone: resp.attributes.phone,
          role: resp.attributes.role,
          created_at: resp.attributes.created_at
        });
      })

      return Promise.resolve({
        data,
        pagination: response.meta.page
      })
    })
}

function getById(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(URL + "/users/${id}", requestOptions).then(handleResponse);
}

function update(user) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(user)
  };

  return fetch(URL + `/users/${user.id}`, requestOptions).then(handleResponse);
}

function promoteRole(user_id, company_id, role) {
  const requestOptions = {
    method: 'PATCH',
    headers: authHeader(),
  };

  return fetch(URL + "/companies/" + company_id + "/users/" + user_id + "?role=" + role, requestOptions).then(handleResponse);
}

function onBoardingQuestions(data) {
  let headers = authHeader();
  headers = { ...headers, 'Content-Type': 'application/json' };

  const requestOptions = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(data)
  };

  return fetch(URL + "/users/questions", requestOptions).then(handleResponse);
}

function getOnboardingPrefill() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(URL + "/users/me/onboarding/prefill", requestOptions).then(handleResponse);
}

function getDefaultSettings() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(URL + "/default-settings", requestOptions)
    .then(handleResponse)
}

function storeDefaultSettings(data) {
  let headers = authHeader();
  console.log("default settings")
  console.log(data);

  const requestOptions = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(data)
  };

  return fetch(URL + "/default-settings", requestOptions).then(handleResponse);
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(user_id, company_id) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  };

  return fetch(URL + "/companies/" + company_id + "/users/" + user_id, requestOptions).then(handleResponse);
}

function handleLoginResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      const error = (data.errors && data.errors[0].detail) || response.statusText;
      return Promise.reject("Datos incorrectos");
    }
    return data;
  });
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        userService.refreshToken();
        return Promise.reject("Intentando recuperar la sesión");
      }

      const error = (data && data.errors[0].detail) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}
